import { z } from 'zod'

export const registryEntrySchema = z.object({
  databaseName: z.string(),
  appName: z.string(),
  roleName: z.string(),
  createdAt: z.string(),
  purpose: z.string().nullish(),
  expiresAt: z.string().nullish(),
  secretArn: z.string(),
})
export type RegistryEntry = z.infer<typeof registryEntrySchema>

export const driftSchema = z.object({
  orphans: z.array(z.string()),
  dangling: z.array(z.string()),
})
export type Drift = z.infer<typeof driftSchema>

export const databasesResponseSchema = z.object({
  registry: z.array(registryEntrySchema),
  pgDatabases: z.array(z.string()),
  drift: driftSchema,
})
export type DatabasesResponse = z.infer<typeof databasesResponseSchema>

export const triggerDumpParamsSchema = z.object({
  databaseName: z.string().min(1),
})
export type TriggerDumpParams = z.infer<typeof triggerDumpParamsSchema>

export const triggerDumpResponseSchema = z.object({
  databaseName: z.string(),
  invocationId: z.string(),
})
export type TriggerDumpResponse = z.infer<typeof triggerDumpResponseSchema>
